// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ValueLabel-primaryButton-1_r67d","valueLabelInput":"ValueLabel-valueLabelInput-2WNZ0J","formatStaticText":"ValueLabel-formatStaticText-3LzUiR"};